(() => {
  const shell = document.getElementById('fm-commerce');
  if (!shell || shell.dataset.connected) return;
  shell.dataset.connected = 'true';
  const config = JSON.parse(shell.querySelector('[data-fm-config]').textContent);
  const t = config.text;
  const root = shell.dataset.root || '/';
  const money = value => new Intl.NumberFormat('zh-TW', { style: 'currency', currency: shell.dataset.currency || 'TWD', maximumFractionDigits: 2 }).format(value / 100);
  const member = shell.dataset.member === 'true';
  const eligibleMember = shell.dataset.memberEligible === 'true';
  const welcome = 'FMMEMBER90';
  let lastFocus;
  let operationBusy = false;
  let quickProduct;
  let quickRequest;
  let quickCart;
  const refreshQuickCart = async () => {
    const node=quickForm.querySelector('[data-fm-cart-quantity]');
    window.FurmosaCart?.select(node,quickForm.elements.id.value);
    try{await window.FurmosaCart?.refresh();}catch{status(quickForm.querySelector('[data-fm-quantity-status]'),'暫時無法確認車內數量，請查看購物車。',true);}
  };
  let toastTimer;
  const status = (node, message, error = false) => {
    if (!node) return;
    node.textContent = message;
    node.dataset.error = String(error);
    node.setAttribute('role', error ? 'alert' : 'status');
  };
  const open = id => {
    const dialog = document.getElementById(id);
    if (!dialog) return;
    const active = document.activeElement;
    const alreadyOpen = shell.querySelector('dialog[open]');
    if (alreadyOpen) alreadyOpen.close();
    lastFocus = active;
    dialog.showModal();
    document.documentElement.classList.add('fm-dialog-open');
  };
  shell.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (!shell.querySelector('dialog[open]')) document.documentElement.classList.remove('fm-dialog-open');
      if (lastFocus?.isConnected && !lastFocus.closest('dialog:not([open])')) lastFocus.focus({ preventScroll: true });
    });
  });
  const toast = message => {
    const node = shell.querySelector('.fm-toast');
    node.querySelector('[data-fm-toast-text]').textContent = message;
    node.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { node.hidden = true; }, 9000);
  };
  const request = async (path, options = {}) => {
    let response;try{response = await fetch(root + path, { credentials: 'same-origin', ...options });}catch(error){if(path==='cart/add.js')throw new Error(t.unknownAdded);throw error;}
    let data;
    try { data = await response.json(); } catch { throw new Error(path==='cart/add.js'?t.unknownAdded:t.failed); }
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || t.failed);
    return data;
  };
  const getCart = () => request('cart.js');
  const updateDiscount = discount => request('cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount }) });
  const codes = cart => (cart.discount_codes || []).map(item => item.code).filter(Boolean);
  const signature = cart => JSON.stringify(cart.items.map(item => [item.key, item.quantity, item.original_line_price]));
  const lock = async action => {
    if (operationBusy||window.fmCartMutationLock) throw new Error(t.locked);
    operationBusy = true;
    window.fmCartMutationLock=true;
    const controls = [...document.querySelectorAll('button,input,select,textarea')].filter(node => !node.disabled && !node.matches('[data-fm-close]'));
    controls.forEach(node => { node.disabled = true; });
    document.querySelectorAll('[data-fm-wallet]').forEach(node => node.setAttribute('aria-busy', 'true'));
    try { return await action(); } finally {
      operationBusy = false;
      window.fmCartMutationLock=false;
      controls.forEach(node => { if (node.isConnected) node.disabled = false; });
      document.querySelectorAll('[data-fm-wallet]').forEach(node => node.removeAttribute('aria-busy'));
    }
  };
  const publishCart = async cart => {
    const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(node => node.dataset.sectionId).filter(Boolean))];
    const sectionMap = {};
    if (sections.length) {
      try {
        const url = new URL(location.href);
        url.searchParams.set('sections', sections.join(','));
        const response = await fetch(url, { credentials: 'same-origin' });
        if (response.ok) Object.assign(sectionMap, await response.json());
      } catch {}
    }
    document.dispatchEvent(new CustomEvent('fm:cart-updated', { detail: cart }));
    try {
      const { CartAddEvent } = await import('@theme/events');
      document.dispatchEvent(new CartAddEvent(cart, 'fm-commerce', { source: 'fm-commerce', itemCount: cart.item_count, sections: sectionMap }));
    } catch {
      document.querySelectorAll('[ref="cartItemCount"]').forEach(node => { node.textContent = String(cart.item_count); });
    }
  };
  const add = async (variantId, quantity, properties = undefined) => {
    if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > 99) throw new Error(t.failed);
    return lock(async () => {
      let response;
      try {
        response = await fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity, ...(properties ? { properties } : {}) }] }) });
      } catch { throw new Error(t.unknownAdded); }
      let data;
      try { data = await response.json(); } catch { throw new Error(t.unknownAdded); }
      if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || t.failed);
      try { await publishCart(await getCart()); } catch {}
      toast(t.added);
      return data;
    });
  };
  const quick = async (handle, variantId) => {
    if (!handle) return;
    if (quickRequest) quickRequest.abort();
    quickRequest = new AbortController();
    const signal = quickRequest.signal;
    quickProduct = undefined;
    const dialog = document.getElementById('fm-quick');
    const form = dialog.querySelector('form');
    const title = dialog.querySelector('h2');
    const image = dialog.querySelector('img');
    const select = form.elements.id;
    const price = dialog.querySelector('[data-fm-quick-price]');
    const submit = form.querySelector('[type=submit]');
    const details = dialog.querySelector('[data-fm-quick-description]');
    const link = dialog.querySelector('[data-fm-quick-link]');
    title.textContent = t.loading;
    price.textContent = '';
    select.replaceChildren();
    submit.disabled = true;
    submit.textContent = t.add;
    image.hidden = true;
    details.textContent = '';
    link.href = root + 'products/' + encodeURIComponent(handle);
    form.elements.quantity.value = '1';
    form.dataset.fmInCart='false';form.querySelector('[data-fm-cart-quantity]').hidden=true;form.querySelector('[data-fm-quantity-status]').textContent='';
    dialog.querySelector('details').open = false;
    status(dialog.querySelector('[data-fm-quick-status]'), '');
    open('fm-quick');
    try {
      const product = await request('products/' + encodeURIComponent(handle) + '.js', { signal });
      if (signal.aborted) return;
      if (product.requires_selling_plan || product.type === 'Bundle' || /客製|組合|月餅|預購/.test(product.title)) {
        location.assign(root + 'products/' + encodeURIComponent(handle));
        return;
      }
      quickProduct = product;
      title.textContent = product.title;
      if (product.featured_image) { image.src = product.featured_image; image.alt = product.title; image.hidden = false; }
      const description = new DOMParser().parseFromString(product.description || '', 'text/html');
      description.querySelectorAll('script,style').forEach(node => node.remove());
      details.textContent = description.body.textContent.trim();
      product.variants.forEach(variant => {
        const option = document.createElement('option');
        option.value = String(variant.id);
        option.textContent = (variant.title === 'Default Title' ? t.defaultVariant : variant.title) + ' · ' + money(variant.price) + (variant.available ? '' : ' · ' + t.soldOut);
        option.disabled = !variant.available;
        select.append(option);
      });
      const choices=dialog.querySelector('[data-fm-variant-choices]');
      if(choices){choices.replaceChildren();product.variants.forEach(variant=>{const button=document.createElement('button');button.type='button';button.dataset.fmVariantChoice=String(variant.id);button.textContent=(variant.title==='Default Title'?t.defaultVariant:variant.title)+' · '+money(variant.price)+(variant.available?'':' · '+t.soldOut);button.disabled=!variant.available;button.addEventListener('click',()=>{if(operationBusy)return;select.value=String(variant.id);select.dispatchEvent(new Event('change'));});choices.append(button);});}
      const preferred = product.variants.find(variant => String(variant.id) === String(variantId) && variant.available) || product.variants.filter(variant => variant.available).sort((a, b) => a.price - b.price)[0];
      if (preferred) select.value = String(preferred.id);
      else { select.selectedIndex = -1; submit.textContent = t.soldOut; }
      select.dispatchEvent(new Event('change'));
      await refreshQuickCart();
    } catch (error) {
      if (signal.aborted) return;
      title.textContent = t.failed;
      status(dialog.querySelector('[data-fm-quick-status]'), error.message, true);
    }
  };
  const quickForm = shell.querySelector('[data-fm-quick-form]');
  quickForm.elements.id.addEventListener('change', () => {
    quickForm.elements.quantity.value='1';
    status(shell.querySelector('[data-fm-quick-status]'),'');
    if(quickProduct) refreshQuickCart().catch(()=>{});
    const variant = quickProduct?.variants.find(item => String(item.id) === quickForm.elements.id.value);
    shell.querySelectorAll('[data-fm-variant-choice]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.fmVariantChoice===quickForm.elements.id.value)));
    shell.querySelector('[data-fm-quick-price]').textContent = variant ? money(variant.price) : '';
    quickForm.querySelector('[type=submit]').disabled = !variant?.available;
    shell.querySelector('[data-fm-quick-link]').href = quickProduct ? root + 'products/' + quickProduct.handle + (variant ? '?variant=' + variant.id : '') : root;
  });
  document.addEventListener('fm:cart-updated',()=>{if(document.getElementById('fm-quick').open&&quickProduct)refreshQuickCart().catch(()=>{});});
  quickForm.addEventListener('submit', async event => {
    event.preventDefault();
    if (!quickForm.reportValidity() || operationBusy) return;
    const variant = quickProduct?.variants.find(item => String(item.id) === quickForm.elements.id.value);
    if (!variant?.available) return;
    const node = shell.querySelector('[data-fm-quick-status]');
    const button = quickForm.querySelector('[type=submit]');
    status(node, t.adding);
    button.textContent = t.adding;
    try { const quantity=Number(quickForm.elements.quantity.value); await add(variant.id, quantity); status(node, '已加入 '+(variant.title==='Default Title'?quickProduct.title:variant.title)+' × '+quantity); quickForm.elements.quantity.value='1'; await refreshQuickCart(); }
    catch (error) { status(node, error.message, true); }
    finally { button.textContent = t.add; }
  });
  const reorderForm=shell.querySelector('[data-fm-reorder-form]');
  reorderForm?.querySelectorAll('[data-reorder-special]').forEach(node=>{node.closest('[data-fm-reorder-row]').querySelector('[name=selected]').disabled=true;});
  reorderForm?.addEventListener('submit',async event=>{
    event.preventDefault();if(operationBusy||!reorderForm.reportValidity())return;
    const rows=[...reorderForm.querySelectorAll('[data-fm-reorder-row]')].filter(row=>row.querySelector('[name=selected]:checked:not(:disabled)'));
    const node=reorderForm.querySelector('[data-fm-reorder-status]');
    if(!rows.length){status(node,'請先勾選要再次購買的商品。');return;}
    status(node,'確認目前價格與庫存中…');
    try{await lock(async()=>{
      const items=[];let changed=false;
      for(const row of rows){
        const product=await request('products/'+encodeURIComponent(row.dataset.handle)+'.js');
        const variant=product.variants.find(v=>String(v.id)===row.dataset.variant);
        if(!variant?.available)throw Error(product.title+' 目前無法購買，請取消勾選或改選規格。');
        if(product.requires_selling_plan||product.type==='Bundle'||/客製|組合|預購/.test(product.title))throw Error(product.title+' 需要重新確認需求，請開啟商品頁。');
        if(variant.price!==Number(row.dataset.price)){row.dataset.price=String(variant.price);row.querySelector('[data-reorder-price]').textContent=money(variant.price)+' · 價格已更新';changed=true;}
        const quantity=Number(row.querySelector('[name=quantity]').value);if(!Number.isSafeInteger(quantity)||quantity<1||quantity>99)throw Error('請輸入 1–99 件。');
        items.push({id:variant.id,quantity});
      }
      if(changed){status(node,'部分價格已變更，請確認上方目前價格後，再按一次加入。');return;}
      await request('cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
      await publishCart(await getCart());rows.forEach(row=>row.querySelector('[name=selected]').checked=false);status(node,'已加入 '+items.reduce((sum,item)=>sum+item.quantity,0)+' 件商品。');toast('已加入勾選的回購商品');
    });}catch(error){status(node,error.message,true);}
  });
  const applyWelcome = async source => {
    if (!member) { open('fm-member'); return; }
    if (!eligibleMember || operationBusy) return;
    const node = source.closest('[data-fm-wallet]')?.querySelector('[data-fm-wallet-status]') || shell.querySelector('[data-fm-member-status]');
    status(node, t.checking);
    try {
      await lock(async () => {
        const before = await getCart();
        if (!before.item_count) throw new Error(t.empty);
        const result = await updateDiscount(welcome);
        const accepted = result.discount_codes?.some(item => item.code.toUpperCase() === welcome && item.applicable);
        if (!accepted) {
          await updateDiscount(codes(before).join(','));
          throw new Error(t.couponUnavailable);
        }
        status(node, t.couponApplied);
      });
      location.assign(root + 'cart');
    } catch (error) { status(node, error.message, true); }
  };
  const removeWelcome = async source => {
    if (operationBusy) return;
    const node = source.closest('[data-fm-wallet]')?.querySelector('[data-fm-wallet-status]');
    try {
      await lock(async () => {
        const cart = await getCart();
        await updateDiscount(codes(cart).filter(code => code.toUpperCase() !== welcome).join(','));
      });
      location.reload();
    } catch (error) { status(node, error.message, true); }
  };
  const compare = async source => {
    if (operationBusy || !member || !eligibleMember) return;
    const wallet = source.closest('[data-fm-wallet]');
    const node = wallet.querySelector('[data-fm-wallet-status]');
    const comparison = wallet.querySelector('[data-fm-comparison]');
    status(node, t.checking);
    comparison.hidden = true;
    try {
      await lock(async () => {
        const before = await getCart();
        if (!before.item_count) throw new Error(t.empty);
        let automatic;
        let coupon;
        let changed = false;
        try {
          changed = true;
          automatic = await updateDiscount('');
          if (signature(automatic) !== signature(before)) throw new Error(t.codeChanged);
          coupon = await updateDiscount(welcome);
          if (signature(coupon) !== signature(before)) throw new Error(t.codeChanged);
        } finally {
          if (changed) {
            try { await updateDiscount(codes(before).join(',')); }
            catch { status(node, t.codeChanged, true); location.assign(root + 'cart'); throw new Error(t.codeChanged); }
          }
        }
        comparison.replaceChildren();
        const row = (label, amount) => {
          const line = document.createElement('div');
          const name = document.createElement('span');
          const value = document.createElement('strong');
          name.textContent = label;
          value.textContent = money(amount);
          line.append(name, value);
          comparison.append(line);
        };
        row(t.applied, before.total_price);
        row(t.automatic, automatic.total_price);
        if (coupon.discount_codes?.some(item => item.code.toUpperCase() === welcome && item.applicable)) row(t.coupon, coupon.total_price);
        else {
          const unavailable = document.createElement('p');
          unavailable.textContent = t.couponUnavailable;
          comparison.append(unavailable);
        }
        const note = document.createElement('p');
        note.textContent = t.compareNote;
        comparison.append(note);
        comparison.hidden = false;
        status(node, '');
      });
    } catch (error) { status(node, error.message, true); }
  };
  const giftForm = shell.querySelector('[data-fm-gift-form]');
  if (giftForm) {
    giftForm.elements.message.addEventListener('input', () => {
      const value = giftForm.elements.message.value;
      shell.querySelector('[data-fm-card-preview]').textContent = value || giftForm.elements.message.placeholder;
      shell.querySelector('[data-fm-card-count]').textContent = value.length + ' / 80';
    });
    giftForm.addEventListener('submit', async event => {
      event.preventDefault();
      if (!giftForm.reportValidity() || operationBusy) return;
      const node = shell.querySelector('[data-fm-gift-status]');
      const message = giftForm.elements.message.value.trim();
      if (!message) { giftForm.elements.message.focus(); return; }
      status(node, t.adding);
      try {
        await add(giftForm.elements.id.value, 1, { '小卡內容': message });
        location.assign(root + 'cart');
      } catch (error) { status(node, error.message, true); }
    });
  }
  document.addEventListener('click', event => {
    const source = event.target.closest('[data-fm-member],[data-fm-reorder],[data-fm-gift],[data-fm-quick],[data-fm-close],[data-fm-coupon],[data-fm-remove-welcome],[data-fm-compare]');
    if (!source) return;
    event.preventDefault();
    if (source.matches('[data-fm-close]')) source.closest('dialog')?.close();
    else if (source.matches('[data-fm-member]')) open('fm-member');
    else if (source.matches('[data-fm-reorder]')) open('fm-reorder');
    else if (source.matches('[data-fm-gift]')) open('fm-gift');
    else if (source.matches('[data-fm-quick]')) quick(source.dataset.fmQuick, source.dataset.fmVariant);
    else if (source.matches('[data-fm-coupon]')) applyWelcome(source);
    else if (source.matches('[data-fm-remove-welcome]')) removeWelcome(source);
    else if (source.matches('[data-fm-compare]')) compare(source);
  });
  document.querySelectorAll('[data-fm-desk]').forEach(desk => {
    const form = desk.querySelector('[data-fm-search]');
    const cards = [...desk.querySelectorAll('[data-fm-catalog-card]')];
    const active = desk.querySelector('[data-fm-active-filters]');
    let filter = 'all';
    let intent = 'daily';
    const giftCards = [...desk.querySelectorAll('[data-fm-gift-card]')];
    const run = () => {
      const raw = form.elements.q.value.trim();
      const budgetMatch = raw.match(/(\d+)\s*(?:元|塊|\$)?\s*(?:以?內|以下|內)/);
      const budget = budgetMatch ? Number(budgetMatch[1]) * 100 : filter === 'budget' ? 20000 : Infinity;
      const soft = /軟|高齡|老年/.test(raw);
      let term = raw.replace(/\d+\s*(?:元|塊|\$)?\s*(?:以?內|以下|內)/g, '').replace(/送朋友|送禮|想買|我想要|零食|的/g, '').trim();
      if (/凍乾/.test(term)) term = '凍乾';
      if (/酥/.test(term)) term = '酥酥的';
      if (/耐咬|咬久/.test(term)) term = '咬咬咬';
      let count = 0;
      const filtered = Boolean(raw || filter !== 'all');
      desk.dataset.filtered = String(filtered || intent === 'gift');
      desk.dataset.intent = intent;
      cards.forEach((card, index) => {
        const title = card.dataset.title;
        const tags = card.dataset.tags;
        const text = title + ' ' + tags;
        const matchesFilter = filter === 'all' || filter === 'budget' || filter === 'freeze' && /凍乾/.test(title) || filter === 'crispy' && /酥酥的|脆脆的/.test(tags) || filter === 'chew' && /咬咬咬/.test(tags);
        const matches = !soft && Number(card.dataset.price) <= budget && matchesFilter && (!term || text.toLocaleLowerCase().includes(term.toLocaleLowerCase()));
        card.hidden = intent === 'gift' || !matches || (!filtered && index >= (desk.classList.contains('fm-discovery') ? 5 : 8));
        if (!card.hidden) count++;
      });
      giftCards.forEach(card => { card.hidden = intent !== 'gift' || Number(card.dataset.price) > budget || Boolean(term && !(card.dataset.title + ' ' + card.dataset.tags).toLocaleLowerCase().includes(term.toLocaleLowerCase())); if (!card.hidden) count++; });
      const giftNote = desk.querySelector('[data-fm-gift-note]'); if (giftNote) giftNote.hidden = intent !== 'gift';
      active.hidden = !filtered;
      desk.querySelector('[data-fm-active-text]').textContent = [raw, filter !== 'all' ? desk.querySelector('[data-fm-filter="' + filter + '"]').textContent : ''].filter(Boolean).join(' · ');
      status(desk.querySelector('[data-fm-search-status]'), count ? (filtered ? t.results.replace('{count}', String(count)) : '') : t.noMatches);
      desk.querySelectorAll('[data-fm-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.fmFilter === filter)));
    };
    desk.querySelectorAll('[data-fm-intent]').forEach(button => button.addEventListener('click', () => { intent = button.dataset.fmIntent; filter = 'all'; form.elements.q.value = ''; desk.querySelectorAll('[data-fm-intent]').forEach(item => item.setAttribute('aria-pressed', String(item === button))); run(); }));
    form.addEventListener('submit', event => { event.preventDefault(); run(); });
    desk.querySelectorAll('[data-fm-filter]').forEach(button => button.addEventListener('click', () => { filter = button.dataset.fmFilter; run(); }));
    desk.querySelector('[data-fm-clear]').addEventListener('click', () => { form.elements.q.value = ''; filter = 'all'; run(); });
    run();
  });
  if (new URL(location.href).searchParams.get('fm_member') === '1') open('fm-member');
})();


